export default class UpdateOrganisationRequest {
    name: string;
    registrationNumber: string = '';
    registrationCountry: string = '';
}

